import React from 'react';
import '../App.css';
import logo from './../assets/DAKLabb-logo-black.png';
import yelpLogo from './../assets/yelp.png';

export default function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          <img src={logo} alt="DAKLabb Logo" className="App-logo"></img>
          <p>Thank you for considering DAKLabb for your project!</p>

          <div className="About">
                  <p>Before I was a software engineer, I was a handyman. I grew up
                      helping my dad on all sorts of home improvement projects, and when I first moved
                      to Australia after college I worked as a handyman to help pay the bills before
                      grad school. Fixing things and solving problems around the home has been a passion
                      of mine all my life and I would love to put that passion to work to hep <b>you!</b></p>
                  <p>As a handyman, I want to solve your problems and leave you happy with the outcome.
                      My goal is to work locally for friends and neighbors providing superior results
                      at a reasonable price. I offer free quotes and a promise that I won't start a job
                      I can't finish, and I won't consider a job finished until you are satisfied with the results.</p>
                  <p>While I'm open to discussing any projects you might have in mind, here are some examples
                      of the types of projects I have worked on recently:
                      <ul>
                        <li>Smart thermostat installation (BGE incentive available)</li>
                        <li>Home automation (mesh networks, smart switches, etc)</li>
                        <li>Basic electrical (replace outlets/switches/light fixtures)</li>
                        <li>Plumbing (fix leaks, upgrade fixtures, caulk showers)</li>                    
                      </ul>
                  </p>
              </div>

          <br/>    
          <p>
            If you have any projects in mind, or questions about services offered, please drop me a voicemail or email and I will get back to you ASAP!
            <br/>
            <br/>
            voicemail: (608) 432-5325
            <br/>
            email: David@DAKLabb.com

          </p>

          <a href="https://yelp.com/biz/LAtdQKx6IjSXwG0Gy83aVA"><img src={yelpLogo} alt="Yelp Profile"
                                                                      className="external-logo-link"></img></a>
        </p>
        <br/>
      </header>
    </div>
  );
}
